import Vue from 'vue';
import Vuex from 'vuex';
import api from '../service/api';
import utils from '../utils/util';
import * as _ from 'lodash';

Vue.use(Vuex);
const store = new Vuex.Store({
  state: {
    skillTypes: [
      {label: "超类", value: 1},
      {label: "大类", value: 2},
      {label: "中类", value: 3},
      {label: "小类", value: 4}
    ],
    skillLevels: [
      {value: 1, label: '初级'},
      {value: 2, label: '中级'},
      {value: 3, label: '高级'},
      {value: 4, label: '专家'}
    ],
    organizationTypes: [
      {value: 1, label: '中心'},
      {value: 2, label: '部门'},
      {value: 3, label: '项目'},
      {value: 4, label: '子部门'}
    ],
    applyStates:[
      {value: -1, label: '待提交'},
      {value: 0, label: '待审核'},
      {value: 1, label: '通过'},
      {value: 2, label: '不通过'},
    ],
    meetingRoles: [ //会审角色
      {value: 1, label: '部门主管'},
      {value: 2, label: '大类看护人'},
      {value: 3, label: '中类看护人'},
      {value: 4, label: '小类看护人'},
      {value: 5, label: '子部门主管'}
    ],
    userStates:[
      {value:1, label:"在职"},
      {value:2, label:"已离职"}
    ],
    processOptions: [
      {label:'项目经理审批', value:"1"},
      {label:'小类看护人', value:"2"},
      {label:'中类看护人', value:"3"},
      {label:'大类看护人', value:"4"},
      {label:'部长', value:"5"},
      {label:'运营总监', value:"6"},
      {label:'其他', value:"99"}
    ],
    users: [],//全量用户
    allSkills: [], //全量技能数组形式
    skillTree: [],//全量技能 for 侧滑和个人技能表
    currentUser:{},//当前登录用户信息
    currentUserSkills:[],//当前登录用户的全量技能树
    // currentUserSkill4s:[],//当前登录用户的全量技能数组（小类）
    allSkills4Mine:[],//全量技能 for 我的技能页面
    organizations: [],// 全量组织架构
    organizationTrees: []
  },
  getters: {
    getProcessOptions: (state) => (value) => {
      let process = state.processOptions.find(item => item.value == value);
      return !!process ? process.label : "";
    },
    getUserState: (state) => (type) => {
      let userState = state.userStates.find(item => item.value == type);
      return !!userState ? userState.label : "";
    },
    getSkillType: (state) => (type) => {
      let skillType = state.skillTypes.find(item => item.value == type);
      return !!skillType ? skillType.label : "";
    },
    getSkillLevel: (state) => (level) => {
      let skillLevel = state.skillLevels.find(item => item.value == level);
      return !!skillLevel ? skillLevel.label : "";
    },
    getOrganizationType: (state) => (level) => {
      let organizationType = state.organizationTypes.find(item => item.value == level);
      return !!organizationType ? organizationType.label : "";
    },
    getApplyState: (state) => (applyState) => {
      let aState = state.applyStates.find(item => item.value == applyState);
      return !!aState ? aState.label : "";
    },
    getCurrentUserName: (state) => {
      let userId = window.localStorage.getItem("userId");
      let user = state.users.find(item => item.value == userId);
      return !!user ? user.label : "";
    },
    getUserNameByUserId: (state) => (userId) => {
      let user = state.users.find(item => item.value == userId);
      return !!user ? user.label : "";
    },
    getTreesByFilterText:(state) => (filterText) => {
      let filterTrees = [];
      let trees = state.skillTree;
      if(filterText != '' && filterText != undefined && filterText != null){
        filterTrees = utils.filterTrees(filterText,'name',trees);
      }else{
        filterTrees = trees;
      }
      return filterTrees;
    },
    getSkillBySkillId: (state) => (skillId) => {
      let skillTrees = _.cloneDeep(state.skillTree);
      let all = [];
      for(let treeNode of skillTrees){
        let nodeArr = [];
        utils.tree2arr(treeNode,nodeArr);
        all = all.concat(nodeArr);
      }
      let skillNode = all.find(item => item.id == skillId);
      return skillNode;
    },
    getMeetingRoleName: (state) => (role) => {
      let meetingRole = state.meetingRoles.find(item => item.value == role)
      return meetingRole ? meetingRole.label : ''
    },
    isAdmin: (state) => {
      let roleList = state.currentUser.roleList
      return !!roleList && !!roleList.find(item => item.id ==0);
    }
  },
  mutations: {
    updateUsers(state, users) {
      state.users = users;
    },
    updateSkillTree(state, skillTree) {
      state.skillTree = skillTree;
    },
    updateCurrentUser(state,currentUser){
      state.currentUser = currentUser;
    },
    updateCurrentUserSkills(state,skills){
      state.currentUserSkills = skills;
    },
    // updateCurrentUserSkill4s(state,skills){
    //   state.currentUserSkill4s = skills;
    // },
    updateAllSkills4Mine(state,skills){
      state.allSkills4Mine = skills;
    },
    updateOrganizations(state,organizations){
      let orgs = [];
      let firstNodes = organizations.filter(node => !organizations.find(item => item.id == node.pid));
      for (let fNode of firstNodes) {
        utils.arr2tree(organizations, fNode);
        orgs.push(fNode);
      }
      state.organizations = organizations;
      state.organizationTrees = orgs;
    },
    updateAllSkills(state, skills) {
      state.allSkills = skills;
    }  },
  actions: {
    queryUsers(context) {
      api.getUserList().then(res => {
        if (res.code == 200) {
          let users = res.result;
          let userOptions = users.map(user => {
            return {value: user.value, label: user.text + "(" + user.value + ")"};
          });
          context.commit('updateUsers', userOptions);
        }
      });
    },
    querySkills(context) {
      api.getSkillList().then(res => {
        if (res.code == 200) {
          let skills = res.result;
          context.commit('updateAllSkills', skills);
          let firstNodes = skills.filter(node => node.pid == 0);
          let skillTree = [];
          for (let fNode of firstNodes) {
            utils.arr2tree(skills, fNode);
            skillTree.push(fNode);
          }
          context.commit('updateSkillTree', skillTree);
          //将技能全量数据，使用localStorage保存一份,只需要保存其id，pid，name
          let allSkills = skills.map(item => {
            return {id: item.id, pid: item.pid, name: item.name};
          });
          window.localStorage.setItem("skills", JSON.stringify(allSkills));
        }
      });
    },
    queryCurrentUser(context){
      api.getUserInfo().then(res => {
          if(res.code == 200){
            let userInfo = res.result;
            context.commit('updateCurrentUser',userInfo);
          }
      })
    },
    queryCurrentUserSkills(context){
      api.getMySkillMap().then(res => {
        if (res.code == 200) {
          let allSkills = res.result;
          let skillMap = [];
          let allSkills4mine = _.cloneDeep(allSkills)
          allSkills4mine.forEach(item => item.disabled = !!item.reviewingSkillLevel || item.skillLevel == 4)
          let fNodes = allSkills4mine.filter(node => node.pid == 0);
          for(let node of fNodes){
            utils.arr2tree(allSkills4mine, node);
            skillMap.push(node);
          }
          context.commit('updateAllSkills4Mine', skillMap);
          // 过滤出已申请技能
          let mySmallSkills = allSkills.filter(item => item.type === 4 && (!!item.skillLevel || !!item.reviewingSkillLevel))
          // context.commit('updateCurrentUserSkill4s',mySmallSkills);
          let parentIds = new Set()
          for (let skill of mySmallSkills) {
            let parentSkill = allSkills.find(item => item.id === skill.pid)
            while (!!parentSkill) {
              parentIds.add(parentSkill.id)
              parentSkill = allSkills.find(item => item.id === parentSkill.pid)
            }
          }
          let parentSkills = allSkills.filter(item => parentIds.has(item.id))
          let mySkills = mySmallSkills.concat(parentSkills)
          let currentSkills = [];
          let firstNodes = mySkills.filter(node => node.pid == 0);
          for(let node of firstNodes){
            utils.arr2tree(mySkills,node);
            currentSkills.push(node);
          }
          context.commit('updateCurrentUserSkills',currentSkills);
        }
      })
    },
    queryOrganization(context) {
      api.getOrganization().then(res => {
        if (res.code == 200) {
          let organizations = res.result;
          context.commit('updateOrganizations', organizations);
        } else {
          this.$message.error(res.msg);
        }
      });
    }
  }
});
export default store;



// WEBPACK FOOTER //
// ./src/store/index.js